var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoaderLatir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 318.07 315.29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-2 {\n        fill: none;\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-width: 0px;\n      }\n\n      .cls-6 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-3 {\n        fill: #fff;\n      }\n\n      .cls-7 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-4 {\n        fill: url(#Degradado_sin_nombre_1269);\n      }\n\n      .cls-5 {\n        fill: url(#Degradado_sin_nombre_1270);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m51.7,43.39C-4.96,95.62-16.17,185.11,32.04,251.07c44.34,60.68,127.23,82.16,196.07,47.92,72.72-36.18,98.21-113.74,83.48-175.17,4.67,23.59,4.16,47.01-2.01,70.28-6.18,23.27-17.21,43.94-33.22,61.92-16.02,17.99-35.26,31.47-57.67,40.36-61.92,24.55-134.79,5.94-176.87-49.52C1.98,194.32.52,121.79,38.89,67.52c19.3-27.3,44.98-46.38,76.81-56.64,41.49-13.37,81.58-9.02,120.57,11.14C214.99,9.37,187.49,1.33,158.25,1.33c-35.66,0-73.9,11.96-106.55,42.06"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_1270",
    "data-name": "Degradado sin nombre 1270",
    x1: 155.15,
    y1: -902.67,
    x2: 156.84,
    y2: -902.67,
    gradientTransform: "translate(-167825.12 29197.66) rotate(-90) scale(186.09 -186.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0099b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#008ca0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#005b7f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#003e6c"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m19.93,157.03c0,77.55,62.87,140.41,140.41,140.41s140.42-62.87,140.42-140.41S237.89,16.62,160.34,16.62,19.93,79.48,19.93,157.03"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m19.93,157.03c0,77.55,62.87,140.41,140.41,140.41s140.42-62.87,140.42-140.41S237.89,16.62,160.34,16.62,19.93,79.48,19.93,157.03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Degradado_sin_nombre_1269",
    "data-name": "Degradado sin nombre 1269",
    x1: 157.07,
    y1: -928.71,
    x2: 158.75,
    y2: -928.71,
    gradientTransform: "translate(26452.22 -154471.73) rotate(-180) scale(166.5)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0081b2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#0082a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#006282"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00496b"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: -36.25,
    y: -28.8,
    width: 382.66,
    height: 388.36,
    transform: "translate(-31.41 294.3) rotate(-81.5)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 19.93,
    y: 16.62,
    width: 280.83,
    height: 280.83
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m63.88,117.34c1.29,18.19,11.95,32.83,27.56,39.63,6.66,2.9,13.46-3.66,11.02-10.5-5.63-15.8-22.35-30.17-38.58-29.13h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m189.56,28.04c-7.33,12.87-7.68,27.35-1.85,39.64,4.02,8.48,16.52,6.29,17.48-3.04,1.42-13.97-4.18-29.98-15.63-36.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m126.3,293.2l1.71,3.4-11.92-3.4c11.92-34.04,8.51-64.68,8.51-64.68-3.4-30.63-49.36-45.95-49.36-45.95-42.55-18.72-54.46-51.06-54.46-51.06l-5.11-10.21,5.11-11.92c5.11,40.85,49.36,56.17,49.36,56.17,27.08,9.28,41.5,18.92,49.17,26.67,3.69,3.73,10.06.76,9.61-4.47-2.38-27.81-17.93-51.14-17.93-51.14-12.13-24.25-47.73-45.3-62.03-53.02-4.36-2.36-8.55-5.01-12.51-7.99l-.35-.26v-13.61c25.53,11.91,66.38,45.95,66.38,45.95,68.08,61.27,23.82,185.52,23.82,185.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m195.24,294.05s-22.13-83.4,15.32-132.75c0,0,42.7-53.01,50.04-67.26.92-1.79,1.86-3.55,2.84-5.31,2.63-4.71,7.06-15.57,5.84-33.8l11.91,15.32s-5.11,37.44-25.53,52.76c0,0-41.59,42.76-54.79,73.85-1.88,4.43,3.58,8.33,7.09,5.04,10.37-9.72,28.33-23.02,54.97-31.12,10.73-3.26,20.48-9.33,27.92-17.73,7.14-8.07,13.46-19.53,14.17-35.13l5.11,27.23s-27.23,40.85-61.27,45.95c0,0-54.46,8.51-49.36,45.95,0,0,0,52.76,8.51,56.17l1.7,6.81-13.62,5.11-.85-11.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m168.86,301.7s-8.51-120.84,22.13-165.09c0,0,49.36-81.7,40.85-108.93l-13.62-6.81s9.43,25.61-13.67,68.42c-3.53,6.54-13.09,5.93-15.67-1.03-2.89-7.79-6.93-16.86-12.1-24.43-4-5.86-7.34-12.17-9.36-18.98-2.79-9.37-4.54-22.21-.26-35.9L151.84.45s-1.59,54.15,9.09,65.39c1.22,1.28,2.42,2.57,3.43,4.02,6.86,9.78,25.85,21.19,20.88,51.09-.32,1.94-3.12,11.2-3.61,13.11-2.89,11.22-7.93,41.11-13.62,51.06,0,0,13.55-39.06-19.52-78.6-1.59-1.9-3.31-3.7-5.09-5.44-5.96-5.85-26.61-29.42-32.41-80.2L107.58.45s-10.21,17.02-10.21,18.72c0,.43.21,1.38.53,2.58,1.63,6.11,2.93,12.29,3.81,18.55,1.87,13.36,7.32,38.19,22.89,53.76,0,0,51.02,46.39,38.12,94.94-1.75,6.6-3.26,13.26-4.08,20.04-2.87,23.68-7.67,73.5,0,92.66h10.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m275.8,131.31c-15.95.86-29.07,9.56-35.94,22.66-3.62,6.9,3.5,14.6,10.71,11.63,13.77-5.66,25.9-20.07,25.23-34.29h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m166.03,93.86c-4.37,9.74-3.21,20.21,2.48,28.3,3,4.26,9.75,2.38,10.19-2.81.85-9.92-4.01-21.54-12.67-25.49h0Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoaderLatir);
export default __webpack_public_path__ + "static/media/loader-latir.47c8a4ecf839f04334d841bfc1931e51.svg";
export { ForwardRef as ReactComponent };